import { render, staticRenderFns } from "./InquiryOpinion.vue?vue&type=template&id=58860f83&"
import script from "./InquiryOpinion.vue?vue&type=script&lang=js&"
export * from "./InquiryOpinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports